/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlMonitTypeAlt = {
    Lite: 'lite',
    Extended: 'extended'
} as const;
export type ControlMonitTypeAlt = typeof ControlMonitTypeAlt[keyof typeof ControlMonitTypeAlt];


export function ControlMonitTypeAltFromJSON(json: any): ControlMonitTypeAlt {
    return ControlMonitTypeAltFromJSONTyped(json, false);
}

export function ControlMonitTypeAltFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMonitTypeAlt {
    return json as ControlMonitTypeAlt;
}

export function ControlMonitTypeAltToJSON(value?: ControlMonitTypeAlt | null): any {
    return value as any;
}

